import { BusinessServices } from '../enums/business-services';
import { Country } from '../enums/countries';

/**
 * Countries served by the NAM business service. `USA` is the deprecated code for `US`
 * and is kept here so profiles still carrying it are not treated as EMEA.
 */
export const NAM_COUNTRIES: Country[] = [Country.US, Country.USA, Country.CA, Country.MX];

/**
 * The business service a user belongs to, derived from their country: NAM countries
 * belong to `OM NAM`, every other country to `OM EMEA`. A profile without a country is
 * not a NAM profile and therefore counts as EMEA.
 *
 * @example
 * getStreamByCountry(Country.MX) // returns 'OM NAM'
 * getStreamByCountry(Country.DE) // returns 'OM EMEA'
 *
 * @param country ISO 3166 country code of the user's profile
 * @returns The business service the country belongs to
 */
export const getStreamByCountry = (country?: Country): BusinessServices =>
    country && NAM_COUNTRIES.includes(country) ? BusinessServices.OM_NAM : BusinessServices.OM_EMEA;

/**
 * Whether a country is served by the given business service. Streams that are not bound to
 * a region, such as `CLW`, cover every country.
 *
 * @param stream The business service to check against
 * @param country ISO 3166 country code
 * @returns `true` if the country belongs to the stream
 */
export const streamCoversCountry = (stream: BusinessServices, country: Country): boolean =>
    stream === BusinessServices.OM_EMEA || stream === BusinessServices.OM_NAM
        ? getStreamByCountry(country) === stream
        : true;
